import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// import JwtService from "@/core/services/jwt.service";
// import axios from "axios";

// action types
export const UPDATE_TABLE_STRUCTURE = "getASNTableStructure";
export const UPDATE_TABLE_DATA = "getASNTableData";
export const EXPORT_TABLE_DATA = "exportASNTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setASNTableStructure";
export const SET_TABLE_DATA = "setASNTableData";
export const SET_TABLE_FILTER = "setASNTableFilter";
export const SET_TABLE_PAGE = "setASNTablePage";
export const SET_TABLE_PERPAGE = "setASNTablePerPage";
export const SET_TABLE_SORTBY = "setASNTableSortBy";
export const SET_TABLE_SORTORDER = "setASNTableSortOrder";
export const SET_EXPORT_LINK = "setASNExportLink";
export const SET_FILTERS_DATA = "setASNFiltersData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  filters_data: [],
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getASNTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getASNTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getASNTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getASNTableHeaders(state) {
    return state.table_structure.columns;
  },

  getASNTableFilters(state) {
    return state.table_structure.filters;
  },

  getASNTableData(state) {
    return state.table_data.data;
  },

  getASNExportUrl(state) {
    return state.export_link;
  },
  getASNUploadType(state) {
    return state.table_structure.types;
  },
  getASNExampleFiles(state) {
    return state.table_structure.example_file;
  },
  getASNExampleUsers(state) {
    return state.table_structure.users;
  },
  getASNPrintTypes(state) {
    return state.table_structure.print_labels;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/fulfillment/asn")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/fulfillment/asn/datatable", payload)
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/fulfillment/asn/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_FILTERS_DATA](state, filter_data) {
    state.filters_data = filter_data;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
